import { RepositoryFabric } from "@api/repositories/RepositoryFabric";
import { client } from "@api/clients/web";

export const repositories = new RepositoryFabric(client);

